import { Accordion, Box, Flex, Heading, StrapiLink, Text, getThemeValue } from "@theme/components";

import type { FooterGroupInterface } from "@ms/gatsby-site/src/types/footer";

/*
Get Column Width

We will always have between 3 and 4 columns in the footer.
First two columns are 25% Width
If we have 3 columns, the last one is 50% width
If we have 4 columns, all columns are 25% width
*/
const getColumnWidth = (length: number, index: number) => {
  if (index === 0 || index === 1) return "1/4";

  return length === 3 ? "1/2" : "1/4";
};

export const FooterLinks = ({
  footerGroup,
  isBlog,
}: {
  footerGroup: FooterGroupInterface[];
  isBlog: boolean;
}) => (
  <>
    {/* Accordion on mobile */}
    <Box
      sx={{
        mb: ["s800"],
        display: ["block", null, "none"],
      }}
    >
      {footerGroup.map((group, idx) => (
        <Accordion
          key={group.title}
          headingLevel={2}
          title={
            <Text as="span" variant="sansBody02MediumPlus" sx={{ color: "white" }}>
              {group.title}
            </Text>
          }
          sx={{
            "& a, & button": {
              variant: "text.sansBody02Regular",
            },
            // TODO: ask if Haewon if we should remove this - not in design system
            ...(idx === 0 && {
              borderTop: (theme) => `1px solid ${getThemeValue(theme, "colors.borderLevel3")}`,
            }),
          }}
        >
          {group.links.map((link) => (
            <Box
              key={link.label}
              sx={
                link.customAction === "OPEN MODAL: Withdrawal from Contract"
                  ? { mb: "s300", "&& span": { fontWeight: "700" } }
                  : { mb: "s300" }
              }
            >
              <StrapiLink {...link} isBlog={isBlog} />
            </Box>
          ))}
        </Accordion>
      ))}
    </Box>

    {/* Links in lists on desktop  */}
    <Flex
      sx={{
        flexWrap: "nowrap",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: "s1000",
        display: ["none", null, "flex"],
      }}
    >
      {footerGroup.map((group, groupIdx) => (
        <Box
          key={group.title}
          sx={{
            width: getColumnWidth(footerGroup.length, groupIdx),
            boxSizing: "border-box",
            pr: "s900",
          }}
        >
          <Heading
            as="h2"
            variant="sansBody01MediumTight"
            sx={{
              color: "goldLight",
              pb: "s600",
            }}
          >
            {group.title}
          </Heading>
          {group.links.map((link) => (
            <Box
              key={link.label}
              sx={
                link.customAction === "OPEN MODAL: Withdrawal from Contract"
                  ? { mb: "s300", "&& span": { fontWeight: "700" } }
                  : { mb: "s300" }
              }
            >
              <StrapiLink {...link} isBlog={isBlog} />
            </Box>
          ))}
        </Box>
      ))}
    </Flex>
  </>
);
